import TableEntityBase from "./TableEntityBase"

export default class ProcessActivityLog extends TableEntityBase {
    Started:string|null = null
    ActivityType:string|null = null
    ActivityName:string|null = null
    Successful:boolean|null = null
    ResultMessage:string|null = null
}